module.exports = __webpack_public_path__ + "static/media/ico-share-toolbar.4e3ce004.svg";